import type { FlowProcess } from '@/features/flow/Flow';

export const NewInsuranceSteps = {
  PHONE: 'phone',
  PLATE_QID: 'plate-qid',
  CHASSIS_NUMBER: 'chassis-number',
  CAR_DETAILS: 'car-details',
  MORE_DETAILS: 'more-details',
  TARIFFS: 'plans',
  SELECT_DEDUCTIBLE: 'select-insurance-plan',
  PLATE_NUMBER: 'plate-number',
  INSURED_INFO: 'insured-info',
  POLICY_DATE: 'policy-date',
  QUOTE: 'quote',
};

export const newFlowPages = {
  ACTIVE_RENEWABLE_POLICY_FOUND: 'active-renewable-policy-found',
  UPCOMING_POLICY_FOUND: 'upcoming-policy-found',
  INSURANCE_RESULT: 'insurance-result',
};

export const newInsuranceOrder: FlowProcess[] = [
  {
    name: NewInsuranceSteps.PHONE,
    isForwardSkip: ({ phone }) => Boolean(phone),
  },
  {
    name: NewInsuranceSteps.PLATE_QID,
    isSkip: ({ isPrefillExperiment }) => !isPrefillExperiment,
  },
  {
    name: NewInsuranceSteps.CHASSIS_NUMBER,
  },
  {
    name: NewInsuranceSteps.CAR_DETAILS,
    isForwardSkip: ({ isCarDetailsFulfilled }) => !!isCarDetailsFulfilled,
  },
  {
    name: NewInsuranceSteps.MORE_DETAILS,
  },
  { name: NewInsuranceSteps.TARIFFS },
  {
    name: NewInsuranceSteps.SELECT_DEDUCTIBLE,
    isSkip: ({ shouldSkipDeductible }) => !!shouldSkipDeductible,
  },
  {
    name: NewInsuranceSteps.PLATE_NUMBER,
  },
  {
    name: NewInsuranceSteps.INSURED_INFO,
  },
  {
    name: NewInsuranceSteps.POLICY_DATE,
  },
  {
    name: NewInsuranceSteps.QUOTE,
  },
  {
    name: newFlowPages.UPCOMING_POLICY_FOUND,
  },
  {
    name: newFlowPages.ACTIVE_RENEWABLE_POLICY_FOUND,
  },
  {
    name: newFlowPages.INSURANCE_RESULT,
  },
];

export const newFlowAnalyticsParams = {
  product: 'carIns',
  category: 'OCR',
};
